import * as React from "react"

import { resolveLinkHref } from "../../shared-components/seo/canonical-tag/utils"
import { EventProperties } from "../../utils/analytics"
import { useLocale } from "../../utils/hooks/use-locale"
import FeatherIcon from "../feather-icon"
import UniversalLink from "../universal-link"
import * as styles from "./index.module.scss"

interface Props {
  to: string
  text: string | React.ReactNode
  variant: "1" | "2"
  target?: "_blank"
  className?: string
  trackingProperties?: EventProperties
  onClick?: () => void
}

function LinkWithArrow({
  to,
  text,
  variant,
  className,
  target,
  trackingProperties,
  onClick,
}: Props) {
  const locale = useLocale()

  return (
    <UniversalLink
      to={resolveLinkHref(to, locale)}
      className={`${styles.link} ${styles[`variant${variant}`]} ${className}`}
      tabIndex={0}
      target={target}
      trackingProperties={trackingProperties}
      onClick={onClick}
    >
      {text}
      <FeatherIcon
        type="chevron-right"
        className={styles.chevronRight}
        size={variant === "1" ? "xlarge" : "large"}
      />
    </UniversalLink>
  )
}

export default LinkWithArrow
